import * as React from "react";
import { Icon } from "../externals";
import "./FileTable.scss";
import FileTableRow from "./FileTableRow";
import FileFilter from "./FileFilter";
import PathSelector from "./PathSelector";
export const FileTable = ({ elements, rootPaths, hasLocations, clickedLocation, clickedRow, filterString, sortedColumn, sorting, classNames, onFilterClean, onFilterChange, onClickedLocation, onClickedRow, onDoubleClick, onClickedHeader, }) => {
    let rows = [];
    let containerRef = React.useRef(null);
    const [rowHeight, setRowHeight] = React.useState(null);
    React.useEffect(() => {
        if (containerRef.current && rowHeight) {
            containerRef.current.scrollTo({
                top: clickedRow * rowHeight,
                left: 0,
                behavior: "auto",
            });
        }
    }, [rowHeight]);
    for (let i = 0; i < elements.length; i++) {
        let clicked = i == clickedRow ? true : false;
        let id = i;
        let row;
        let handleDoubleClick = (path) => () => {
            onDoubleClick && onDoubleClick(path);
        };
        if (elements[i].type == "DIRECTORY" || elements[i].name === "..") {
            row = (React.createElement(FileTableRow, { setHeight: setRowHeight, type: elements[i].type, name: elements[i].name, size: elements[i].size, lastModifiedDate: elements[i].lastModifiedDate, isClicked: clicked, key: i, onClick: () => {
                    onClickedRow(id);
                }, onDoubleClick: typeof elements[i].path !== "undefined"
                    ? handleDoubleClick(elements[i].path)
                    : handleDoubleClick(elements[i].name) }));
        }
        else {
            row = (React.createElement(FileTableRow, { setHeight: setRowHeight, type: elements[i].type, name: elements[i].name, size: elements[i].size, lastModifiedDate: elements[i].lastModifiedDate, isClicked: clicked, key: i, onClick: () => {
                    onClickedRow(id);
                } }));
        }
        rows.push(row);
    }
    let pathSelectors = [];
    if (hasLocations && rootPaths) {
        for (let i = 0; i < rootPaths.length; i++) {
            let id = i;
            pathSelectors.push(React.createElement(PathSelector, { id: id, name: rootPaths[i].name, iconName: rootPaths[i].iconName, isClicked: clickedLocation === id, onClick: (id) => onClickedLocation && onClickedLocation(id), key: id }));
        }
    }
    const selectorDiv = React.createElement("div", { className: "pathselector-field" }, pathSelectors);
    let icons = [];
    let columnIds = ["name", "size", "lastModifiedDate"];
    const downArrowIcon = React.createElement(Icon, { size: 16, icon: "chevron-down" });
    const upArrowIcon = React.createElement(Icon, { size: 16, icon: "chevron-up" });
    if (sortedColumn !== "") {
        const Arrow = sorting > 1 ? downArrowIcon : upArrowIcon;
        for (var i = 0; i < columnIds.length; i++) {
            if (columnIds[i] === sortedColumn)
                icons.push(Arrow);
            else
                icons.push("");
        }
    }
    return (React.createElement("div", { className: "filetable " + classNames },
        React.createElement("div", null,
            selectorDiv,
            React.createElement(FileFilter, { filterString: filterString, onFilterClean: onFilterClean, onInputChange: onFilterChange })),
        React.createElement("div", null,
            React.createElement("div", { className: "filetable-header" },
                React.createElement("div", { className: "filetablerow-cell-icon" }),
                React.createElement("div", { className: "filetablerow-cell-name", role: "columnheader" },
                    React.createElement("a", { className: "header-orderer", id: columnIds[0], tabIndex: 0, onClick: onClickedHeader },
                        "Name",
                        icons[0])),
                React.createElement("div", { className: "filetablerow-cell-size", role: "columnheader" },
                    React.createElement("a", { className: "header-orderer", id: columnIds[1], tabIndex: 1, onClick: onClickedHeader },
                        "Size",
                        icons[1])),
                React.createElement("div", { className: "filetablerow-cell-date", role: "columnheader" },
                    React.createElement("a", { className: "header-orderer", id: columnIds[2], tabIndex: 2, onClick: onClickedHeader },
                        "Last Modified Date",
                        icons[2]))),
            React.createElement("div", { className: "filetable-bodycontainer" },
                React.createElement("div", { className: "filetable-body", ref: containerRef }, rows)))));
};
//# sourceMappingURL=FileTable.js.map